import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Input from '../_Components/Input'
import { useDispatch } from 'react-redux'
import { updateDashboardData } from '../../Store/dashboardSlice'
import { call } from '../../Methods'
import { use } from '../../Helpers'
import OrderItemRow  from './OrderItemRow'

function _OrderView () {
  const pageTitle = 'Orders'
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [order, setOrder] = useState()
  const [orderItems, setOrderItems] = useState([])
  const [countries, setCountries] = useState([])
  const [statuses, setStatuses] = useState([])
  const [alertBoxParameters, setAlertBoxParameters] = useState({
    active: false,
    type: '',
    message: ''
  })
  const [loading, setLoading] = useState(false)

  async function getData () {
    setLoading(true)
    const _countries = await call.forLoggedUser.country.getCountryList({})
    if (_countries.success) {
    }
    setCountries(
      _countries.data.map(({ id, name }) => {
        return { value: id, text: name }
      })
    )

    const _statuses = await call.forLoggedUser.statuses.getStatuses({
      type: 'Order'
    })
    if (_statuses?.success) {
      setStatuses(_statuses.data)
    }

    let _order = await call.forLoggedUser.order.getOrder(id)
    if (_order.success) {
      _order = _order.data
      if (_order?.statusId === 0) {
        let order = { id: id, statusId: 1 }
        const updateOrderResponse =
          await call.forLoggedUser.order.updateOrderStatus(order)
        let dashboardInfo =
          await call.forLoggedUser.dashboard.getdashboardinfo()
        dispatch(updateDashboardData({ _newOrders: dashboardInfo.newOrders }))
        //_orderResponse = updateOrderResponse.data.data;
      }
      setOrder(_order)
      setOrderItems(_order.orderItems)
    }
    setLoading(false)
  }

  async function updateOrder () {
    let _order = {}
    _order.id = id
    _order.userId = use.getInputValueByName('userId')

    let order_items_array = []
    let _rows = document.querySelectorAll('#sub-items .sub-items-row')
    _rows.forEach(_r => {
      order_items_array.push(
        new Object({
          id: +_r.dataset.index,
          item_priceId: +_r.dataset.priceid,
          sizeId: +use.getInputValueByName('sizeId', _r),
          substrateId: +use.getInputValueByName('substrateId', _r),
          singleItemPrice: +use.getInputValueByName('singleItemPrice', _r),
          quantity: +use.getInputValueByName('quantity', _r)
        })
      )
    })

    _order.orderItems = order_items_array
    //return false;
    const _updateOrderResponse = await call.forLoggedUser.order.updateOrder(
      _order
    )
    if (_updateOrderResponse.success) {
      setAlertBoxParameters({
        active: true,
        type: 'success',
        message: 'Successfully saved',
        timeout: 5000
      })
      setOrder(_updateOrderResponse.data)
    } else {
      setAlertBoxParameters({
        active: true,
        type: 'error',
        message: 'Something bad happened',
        timeout: 5000
      })
    }
  }

  const updateStatus = async e => {
    setLoading(true)
    let _order = {
      id: id,
      statusId: use.getInputValueByName('statusId')
    }

    const _updateStatusResponse = await call.forLoggedUser.order.updateOrder(
      _order
    )
    if (_updateStatusResponse.success) {
      console.log(_updateStatusResponse.data)
      setOrder(_updateStatusResponse.data)
      navigate(`/admin/order/${_updateStatusResponse.data.id}`, {
        replace: true
      })
    }
    setLoading(false)
  }

  const addPriceRow = () => {
    let _newRow = [...orderItems]
    _newRow.push({ id: _newRow.length, sizeId: 0, substrateId: 0, price: 0 })
    setOrderItems(_newRow)
  }

  useEffect(() => {
    getData()
  }, [id])

  return (
    !loading &&
    order &&
    statuses &&
    countries && (
      <React.Fragment>
        <form className='form'>
          <h4 className='form-title'>
            {pageTitle} {' / '} {order.orderNumber}
            <span
              style={{
                marginLeft: '20px',
                backgroundColor: use.colorsByValues([order.statusId])
              }}
              className='status-label'
            >
              {order.statusName}
            </span>
          </h4>
          <label className='group-label'>User</label>
          <p>{order.userEmail}</p>
          <label className='group-label'>Order</label>
          <div className='row'>
            <Input
              type={'text'}
              label={'Number'}
              disabled={true}
              fieldName={'orderNumber'}
              col={{ default: 12, sm: 6, md: 3 }}
              value={order.orderNumber}
            />
            <Input
              type={'text'}
              label={'Sub Total'}
              fieldName={'subTotal'}
              disabled={true}
              col={{ default: 12, sm: 6, md: 3 }}
              value={order.subTotal}
            />
            <Input
              type={'text'}
              label={'HST'}
              fieldName={'hst'}
              disabled={true}
              col={{ default: 12, sm: 6, md: 3 }}
              value={order.hst}
            />
            <Input
              type={'text'}
              label={'Discount'}
              fieldName={'discountCode'}
              disabled={true}
              col={{ default: 12, sm: 6, md: 3 }}
              value={order.discountCode}
            />
            <Input
              type={'text'}
              label={'Total Amount'}
              fieldName={'totalAmount'}
              disabled={true}
              col={{ default: 12, sm: 6, md: 3 }}
              value={use.normalizePrecision(order.totalAmount)}
            />
            <Input
              type={'text'}
              label={'Order Date'}
              fieldName={'createDate'}
              disabled={true}
              col={{ default: 12, sm: 6, md: 3 }}
              value={use.convertUTCToLocalISOString(order.createDate)}
            />

            <Input
              type={'text'}
              label={'Last Modified'}
              fieldName={'modifiedDate'}
              disabled={true}
              col={{ default: 12, sm: 6, md: 3 }}
              value={order.modifiedDate? use.convertUTCToLocalISOString(order.modifiedDate) : '-'}
            /> 
            
          </div>
          <label className='group-label'>Order Items</label>
          <React.Fragment>
            <div id='sub-items'>
              {orderItems && orderItems.map((oi, index) => {
                  oi.rowOrder = index + 1
                  return (
                    <OrderItemRow
                      key={index}
                      orderItem={oi}
                    />
                  )
                })}
            </div>
          </React.Fragment>
          <div className='action-buttons'>
            <button
              type='button'
              className='back-button'
              onClick={() => navigate('/admin/orders', { replace: true })}
            >
              Back
            </button>
            <button type='button' className='save-button' onClick={()=>console.log('updateOrder')}>
              Save
            </button>
            <button type='button' className='delete-button'>
              Delete
            </button>
          </div>
        </form>
        <form className='form'>
          <div id='status-row' className='row'>
            <label className='group-label'>Set Status</label>
            <Input
              type={'select'}
              label={'Status'}
              fieldName={'statusId'}
              data={statuses.map(({ id, statusName }) => {
                return { value: id, text: statusName }
              })}
              col={{ default: 12, sm: 4, md: 3 }}
              defaultValue={order.statusId.toString()}
            />
            <Input
              type={'button'}
              fieldName={'Update'}
              className={'action-button approve-button'}
              style={{ position: 'relative', top: '17px' }}
              col={{ default: 12, sm: 4, md: 2 }}
              value={'Update'}
              eventHandler={[{ type: 'click', handler: updateStatus }]}
            />
          </div>
        </form>
      </React.Fragment>
    )
  )
}

export default _OrderView